export enum EFileError {

	DirectoryAlreadyExist = 0,
	DirectoryNotFound,
	FileAlreadyExist,
	FileNotFound,
	Other,
	copyTo,
	remove
}